import * as UI from './layout.styled'

export const LayoutUI = UI
